import { getDefaultState } from './default'

import {
  WARRANTY_CLEAR_MODULE,
  WARRANTY_UPDATE_CREATED,
  WARRANTY_UPDATE_SINISTER_ID,
  WARRANTY_UPDATE_SECONDARY_ID,
  WARRANTY_UPDATE_ZIP_CODE,
  WARRANTY_UPDATE_ADDRESS,
  WARRANTY_UPDATE_COORDINATES,
  WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
  WARRANTY_UPDATE_PROPERTY_TYPE,
  WARRANTY_UPDATE_RESIDENT_TYPE,
  WARRANTY_UPDATE_OBSERVATIONS,
  WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE,
  WARRANTY_UPDATE_SINISTER_SUMMARY,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_MATERIAL_SUMMARY,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORTS_SURFACE,
  WARRANTY_ADD_FORMS,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_UPDATE_DAMAGED_ITEM,
  WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS,
  WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS,
  WARRANTY_UPDATE_MURS_TOTAL_COUNT,
  WARRANTY_UPDATE_MURS_COUNT,
  WARRANTY_UPDATE_REPORTS_MURS,
  WARRANTY_CLEAR_REPORT_MURS,
  WARRANTY_UPDATE_REPORTS_PROPERTIES,
  WARRANTY_UPDATE_REPORTS_BY_CATEGORY,
  WARRANTY_CLEAR_REPORT_BY_CATEGORY,
  WARRANTY_UPDATE_ID,
  WARRANTY_ADD_REPORTS,
  WARRANTY_UPDATE_DAMAGED_PART_KEY,
  WARRANTY_UPDATE_DAMAGED_ITEM_KEY,
  WARRANTY_UPDATE_LAST_SELECTED_KEY,
  WARRANTY_UPDATE_LAST_SELECTED_VALUE,
  WARRANTY_UPDATE_ID_CATEGORY_SUBTYPE,
  WARRANTY_UPDATE_CATEGORIES_QTY,
  WARRANTY_UPDATE_CATEGORIES_MOBILIER,
  WARRANTY_UPDATE_LITERALS_MOBILIER,
  WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
  WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
  WARRANTY_CLEAR_MOBILIER_PROPERTIES,
  WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES,
  WARRANTY_UPDATE_PRODUCT_ID_UPTEC_FEATURE,
  WARRANTY_UPDATE_OBJ_UPTEC,
  WARRANTY_UPDATE_RESULT_DECLARATION,
  WARRANTY_UPDATE_DAMAGE_TYPE_LITERAL,
  WARANTY_UPDATE_HAS_UPPTEC_DAMAGE,
  WARRANTY_UPDATE_IS_MULTIDAMAGE,
  WARRANTY_UPDATE_MULTIDAMAGE,
  WARANTY_UPDATE_REP_TYPE,
  WARANTY_UPDATE_WARRANTIES
} from '@/store/types'

export default {
  [WARRANTY_UPDATE_DAMAGE_TYPE_LITERAL](state, payload) {
    state.damageTypeLiteral = payload
  },
  [WARRANTY_UPDATE_RESULT_DECLARATION](state, payload) {
    state.resultDeclaration = payload
  },
  [WARANTY_UPDATE_REP_TYPE](state, payload) {
    state.repDeclaration = payload
  },
  [WARANTY_UPDATE_WARRANTIES](state, payload) {
    state.warranties = payload
  },
  [WARANTY_UPDATE_HAS_UPPTEC_DAMAGE](state, payload) {
    state.hasUpptecDamage = payload
  },
  [WARRANTY_UPDATE_OBJ_UPTEC](state, payload) {
    state.objUptec[payload.key] = payload.value
  },
  [WARRANTY_UPDATE_PRODUCT_ID_UPTEC_FEATURE](state, payload) {
    state.productIdUptecFeature = payload
  },
  [WARRANTY_UPDATE_LAST_SELECTED_PROPERTIES](state, payload) {
    state.keysMobilier[payload.category] = payload.key
  },
  [WARRANTY_UPDATE_IS_MULTIDAMAGE](state, payload) {
    state.isMultidamage = payload
  },
  [WARRANTY_UPDATE_MULTIDAMAGE](state, payload) {
    state.multidamage = payload
  },
  [WARRANTY_CLEAR_MOBILIER_PROPERTIES](state) {
    state.literalsMobilier = []
    state.categoriesQty = null
    state.categoriesMobilier = null
    state.categoryFinalLevel = false
    state.keysMobilier = {}
    state.objUptec = {}
  },
  [WARRANTY_UPDATE_CATEG_FINAL_LEVEL](state, payload) {
    state.categoryFinalLevel = payload
  },
  [WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER](state, payload) {
    state.textInputSearchMobilier = payload
  },
  [WARRANTY_UPDATE_LITERALS_MOBILIER](state, payload) {
    state.literalsMobilier[payload.category] = payload.literal
  },
  [WARRANTY_UPDATE_CATEGORIES_MOBILIER](state, payload) {
    state.categoriesMobilier = payload
  },
  [WARRANTY_UPDATE_CATEGORIES_QTY](state, payload) {
    state.categoriesQty = payload
  },
  [WARRANTY_UPDATE_ID_CATEGORY_SUBTYPE](state, payload) {
    state.categoryId = payload.category
    state.subtypeId = payload.subtype
  },
  [WARRANTY_UPDATE_DAMAGED_PART_KEY](state, payload) {
    state.damagedPartKey = payload
  },
  [WARRANTY_UPDATE_DAMAGED_ITEM_KEY](state, payload) {
    state.damagedItemKey = payload
  },
  [WARRANTY_UPDATE_LAST_SELECTED_VALUE](state, payload) {
    state.lastSelectedValue = payload
  },
  [WARRANTY_UPDATE_LAST_SELECTED_KEY](state, payload) {
    state.lastSelectedKey = payload
  },
  [WARRANTY_CLEAR_REPORT_MURS](state, payload) {
    state.counterMurs = 1
  },
  [WARRANTY_ADD_REPORTS](state, payload) {
    state.report.push(payload)
  },
  [WARRANTY_UPDATE_ID](state, payload) {
    state.warrantyId = payload
  },
  [WARRANTY_CLEAR_REPORT_BY_CATEGORY](state, payload) {
    state.report = state.report.filter((report) => {
      const reportValue = report[state.damagedPartKey]
      if (typeof reportValue === 'string') {
        if (reportValue.indexOf(payload) === -1) {
          return report
        }
      }
    })
  },
  [WARRANTY_UPDATE_REPORTS_BY_CATEGORY](state, payload) {
    let category = payload.category
    state.report.forEach((report) => {
      const reportCategory = report[state.damagedPartKey]
      if (typeof reportCategory === 'string') {
        if (reportCategory.indexOf(category) !== -1) {
          report[payload.key] = payload.value
        }
      }
    })
  },
  [WARRANTY_UPDATE_REPORTS_SURFACE](state, payload) {
    state.report.forEach((report) => {
      if (parseInt(report.ROOM_SURFACE) >= 0) {
        report[payload.key] = payload.value
      }
    })
  },
  [WARRANTY_UPDATE_REPORTS_PROPERTIES](state, payload) {
    state.report.forEach((report) => {
      report[payload.key] = payload.value
    })
  },
  [WARRANTY_UPDATE_REPORTS_MURS](state, payload) {
    state.report.forEach((report) => {
      if (report.SUPPORT.indexOf('MUR') !== -1) {
        report.SUPPORT = payload + 'MUR'
        report.QUANTITY = payload
      }
    })
  },
  [WARRANTY_UPDATE_MURS_TOTAL_COUNT](state, payload) {
    state.counterMurs = parseInt(payload)
  },
  [WARRANTY_UPDATE_MURS_COUNT](state, payload) {
    state.counterMurs += parseInt(payload)
  },
  [WARRANTY_CLEAR_SELECTED_DAMAGED_PARTS](state) {
    state.selectedDamagedParts = []
  },
  [WARRANTY_UPDATE_SELECTED_DAMAGED_PARTS](state, payload) {
    const duplicateDamagedPart = state.selectedDamagedParts.find(
      (damagedPart) => damagedPart.literal === payload.literal
    )
    const indexDuplicate =
      state.selectedDamagedParts.indexOf(duplicateDamagedPart)
    if (state.selectedDamagedParts.length >= 1 && duplicateDamagedPart) {
      state.selectedDamagedParts.splice(indexDuplicate, 1)
    } else {
      state.selectedDamagedParts.push(payload)
    }
  },
  [WARRANTY_ADD_FORMS](state, payload) {
    state.forms.push(payload)
  },
  [WARRANTY_UPDATE_DAMAGED_ITEM](state, payload) {
    state.damagedItem = payload
  },
  [WARRANTY_UPDATE_REPORT](state, payload) {
    // Find if there is an existing report with the same payload key and same payload value
    const existingReport = state.report.find(
      (report) => report[state.lastSelectedKey] === payload.value
    )

    if (state.report.length) {
      // if the state.report array has already objects created evaluate if the keys/values are not duplicated

      if (
        state.lastSelectedKey === payload.key &&
        state.lastSelectedValue !== payload.value &&
        !existingReport
      ) {
        // For multiselect purpose - if it's selected another element with the same key but different value, will find the object with the last selected key
        const targetReport = state.report.find(
          (report) => report[state.lastSelectedKey] === state.lastSelectedValue
        )

        // Assign the properties of the found object to a new one
        const newReport = { ...targetReport }

        // Add a different value to the new object
        newReport[payload.key] = payload.value

        // Push the new object to the report state
        state.report.push(newReport)

        // Change the last selected value and key
        state.lastSelectedValue = payload.value
        state.lastSelectedKey = payload.key
      } else if (state.lastSelectedKey !== payload.key && !existingReport) {
        // If the payload key was not selected before, find the report object which was last modified
        const targetReport = state.report.find(
          (report) => report[state.lastSelectedKey] === state.lastSelectedValue
        )

        // Add a the payload key and value to this object
        targetReport[payload.key] = payload.value

        // Change the last selected value and key
        state.lastSelectedValue = payload.value
        state.lastSelectedKey = payload.key
      } else if (existingReport) {
        state.report = state.report.filter(
          (report) => report !== existingReport
        )
      }
    } else {
      // If it's the first time the report state is being changed, create an object and add the payload key and value to the new object
      const obj = {}
      obj[payload.key] = payload.value

      // Push the object in the state.report array
      state.report.push(obj)

      // Change the last selected value and key
      state.lastSelectedValue = payload.value
      state.lastSelectedKey = payload.key
    }
  },
  [WARRANTY_CLEAR_FORMS](state, payload) {
    state.forms = []
  },
  [WARRANTY_CLEAR_MODULE](state, payload) {
    Object.assign(state, getDefaultState())
  },
  [WARRANTY_UPDATE_CREATED](state, payload) {
    state.created = typeof payload === 'boolean' ? payload : false
  },
  [WARRANTY_UPDATE_SINISTER_ID](state, payload) {
    state.sinisterId = payload
  },
  [WARRANTY_UPDATE_SECONDARY_ID](state, payload) {
    state.secondaryId = payload
  },
  [WARRANTY_UPDATE_ADDRESS](state, payload) {
    state.address = payload
  },
  [WARRANTY_UPDATE_ZIP_CODE](state, payload) {
    state.zipCode = payload
  },
  [WARRANTY_UPDATE_COORDINATES](state, payload) {
    state.coordinates = payload
  },
  [WARRANTY_UPDATE_MORE_THAN_TWO_YEARS](state, payload) {
    state.moreThanTwoYears = payload
  },
  [WARRANTY_UPDATE_PROPERTY_TYPE](state, payload) {
    state.propertyType = payload
  },
  [WARRANTY_UPDATE_RESIDENT_TYPE](state, payload) {
    state.residentType = payload
  },
  [WARRANTY_UPDATE_OBSERVATIONS](state, payload) {
    state.observations = payload
  },
  [WARRANTY_UPDATE_DAMAGE_REP_TYPE_CODE](state, payload) {
    state.damage.rep_type_code = payload
  },
  [WARRANTY_UPDATE_SINISTER_SUMMARY](state, payload) {
    // checks if there is no update in the items
    if (JSON.stringify(state.sinisterSummary) === JSON.stringify(payload)) {
      return
    }
    state.damagesCategories = payload
    state.sinisterSummary = []
    payload.forEach((damage) => {
      state.sinisterSummary = [...state.sinisterSummary, ...damage.items]
      if (damage.pieces_max_id.length > 0)
        state.maxPiecesId = damage.pieces_max_id
    })
  },
  [WARRANTY_CLEAR_REPORT](state, payload) {
    state.report = []
  },
  [WARRANTY_UPDATE_MATERIAL_SUMMARY](state, payload) {
    state.materialSummary = payload
  }
}
